import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Header from './Component/Header';
import Footer from './Component/Footer';
import ScrollToTop from './Component/ScrollToTop';
import ChatBot from './Component/ChatBot';
import Home from './Screens/Home';

const Applications = lazy(() => import('./Screens/Applications'));
const Services = lazy(() => import('./Screens/Services'));
const Connect = lazy(() => import('./Screens/Connect'));
const AdminLogin = lazy(() => import('./Screens/Admin').then((mod) => ({ default: mod.AdminLogin })));
const AdminStudio = lazy(() => import('./Screens/Admin').then((mod) => ({ default: mod.AdminStudio })));
const Careers = lazy(() => import('./Screens/Careers'));
const Contact = lazy(() => import('./Screens/Contact'));
const Privacy = lazy(() => import('./Screens/Privacy'));
const ViewPost = lazy(() => import('./Screens/ViewPost'));
const Forget = lazy(() => import('./Screens/Forget'));
const Reset = lazy(() => import('./Screens/Reset'));
const PostCreate = lazy(() => import('./Screens/PostCreate'));
const PostView = lazy(() => import('./Screens/PostView'));
const PostEdit = lazy(() => import('./Screens/PostEdit'));
const RecruitmentCreate = lazy(() => import('./Screens/RecruitmentCreate'));
const RecruitmentView = lazy(() => import('./Screens/RecruitmentView'));
const RecruitmentEdit = lazy(() => import('./Screens/RecruitmentEdit'));
const InventoryManagement = lazy(() => import('./Screens/InventoryManagement'));
const ProcureToPay = lazy(() => import('./Screens/ProcureToPay'));
const MasterDataSolution = lazy(() => import('./Screens/MasterDataSolution'));
const ProcurementServices = lazy(() => import('./Screens/ProcurementServices'));
const CoManagedServices = lazy(() => import('./Screens/CoManagedServices'));
const TailSpendManagement = lazy(() => import('./Screens/TailSpendManagement'));
const InventoryServices = lazy(() => import('./Screens/InventoryServices'));
const ProcurementConsulting = lazy(() => import('./Screens/ProcurementConsulting'));
const JobsApplications = lazy(() => import('./Screens/JobsApplications'));
const JobApplicationView = lazy(() => import('./Screens/JobApplicationView'));
const Invite = lazy(() => import('./Screens/Invite'));
const InviteAccept = lazy(() => import('./Screens/InviteAccept'));
const AdminView = lazy(() => import('./Screens/AdminView'));

function PageFallback() {
  return <div className="page-fallback" aria-hidden="true" />;
}

function AppLayout() {
  const location = useLocation();

  return (
    <div className="app">
      <ScrollToTop />
      <Header />
      <main key={location.pathname} className="page-enter">
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/services" element={<Services />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/forget" element={<Forget />} />
            <Route path="/reset-password" element={<Reset />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/admin/studio" element={<AdminStudio />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/view-post/:id" element={<ViewPost />} />
            <Route path="/create-post" element={<PostCreate />} />
            <Route path="/admin/view-post/:id" element={<PostView />} />
            <Route path="/edit-post/:id" element={<PostEdit />} />
            <Route path="/create-recruitment" element={<RecruitmentCreate />} />
            <Route path="/view-recruitment/:id" element={<RecruitmentView />} />
            <Route path="/edit-recruitment/:id" element={<RecruitmentEdit />} />
            <Route path="/inventory-management" element={<InventoryManagement />} />
            <Route path="/procure-to-pay" element={<ProcureToPay />} />
            <Route path="/master-data-solution" element={<MasterDataSolution />} />
            <Route path="/procurement-services" element={<ProcurementServices />} />
            <Route path="/co-managed-services" element={<CoManagedServices />} />
            <Route path="/tail-spend-management" element={<TailSpendManagement />} />
            <Route path="/inventory-services" element={<InventoryServices />} />
            <Route path="/procurement-consulting" element={<ProcurementConsulting />} />
            <Route path="/jobs-applications" element={<JobsApplications />} />
            <Route path="/job-application-view/:id" element={<JobApplicationView />} />
            <Route path="/invite" element={<Invite />} />
            <Route path="/accept-invite" element={<InviteAccept />} />
            <Route path="/invite-accept" element={<InviteAccept />} />
            <Route path="/admin/view/:id" element={<AdminView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
